<template>
    <input
        ref="input"
        class="form_control icon_date jsDatepickerInput"
        :class="customClass"
        type="text"
        placeholder="DD/MM/YY"
    />
</template>

<script>
import { mapGetters } from 'vuex';

import 'jquery-ui/themes/base/datepicker.css';
import datepickerLanguages from '@/helpers/datepickerLanguages';

export default {
    props: {
        value: {
            type: String,
            default: null
        },
        minDate: {
            type: Date,
            default: null
        },
        maxDate: {
            type: Date,
            default: null
        },
        customClass: {
            type: String,
            default: ''
        }
    },

    computed: {
        ...mapGetters(['locale'])
    },

    watch: {
        locale() {
            if (process.client) {
                const $ = window.jQuery;

                $.datepicker.setDefaults($.datepicker.regional[this.locale]);
            }
        },

        minDate() {
            if (process.client) {
                const $ = window.jQuery;
                const $input = $(this.$refs.input);

                $input.datepicker('option', {
                    minDate: this.minDate || null
                });
            }
        },

        maxDate() {
            if (process.client) {
                const $ = window.jQuery;
                const $input = $(this.$refs.input);

                $input.datepicker('option', {
                    maxDate: this.maxDate || null
                });
            }
        },

        value(newDate) {
            this.setDate(newDate);
        }
    },

    mounted() {
        const $ = window.jQuery;
        const $input = $(this.$refs.input);

        if (!$.datepicker) {
            require('jquery-ui/ui/widgets/datepicker');
        }

        $.datepicker.setDefaults(datepickerLanguages[this.locale || 'en']);

        $input.datepicker({
            showOtherMonths: true,
            changeYear: true,
            changeMonth: true,
            autoSize: true,
            dateFormat: 'dd/mm/y',
            onSelect: date => {
                const [day, month, year] = date.split('/');

                this.$emit('input', `20${year}-${month}-${day}`);
            },
            minDate: this.minDate || null,
            maxDate: this.maxDate || null
        });

        this.setDate(this.value);
    },

    methods: {
        setDate(newDate) {
            if (process.client) {
                const $ = window.jQuery;
                const $input = $(this.$refs.input);

                if (!newDate) {
                    $input.datepicker('setDate', null);

                    return;
                }

                const date = this.$dayjs(newDate).toDate();

                $input.datepicker('setDate', date);
            }
        }
    }
};
</script>
